import { useMutation } from '@tanstack/react-query';

import { organizationServices } from '@hero/services';

export const useResendAuthEmail = options => {
  return useMutation(body => organizationServices.resendCode(body), {
    ...options
  });
};
